import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { APP_BASE_URL } from "../../Common/EndPoints";
export const apiBase = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${APP_BASE_URL}`,
    prepareHeaders: (headers) => {
      // Get token from window object (set by axios interceptor)
      const token = window.jwtToken || localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [""],
  endpoints: () => ({}),
});
